// skipcq: JS-W1028
export const CRAWL_TYPES = ['google_maps_search', 'socials'];
export const TARGET_TYPES = ['brewery'];
export const CADENCES = ['daily', 'weekly', 'monthly', 'quarterly'];
export const STATUSES = ['active', 'paused', 'error_suppressed'];

export const DATETIME_INPUT_LABEL_PROPS = { shrink: true };

export function buildScheduleId(crawlType, targetType, targetId) {
  const sanitizedTargetId =
    targetId == null ? '' : String(targetId).trim();
  return `${crawlType}__${targetType}__${sanitizedTargetId}`;
}

export const SCHEDULE_FIELD_DEFAULTS = {
  crawlType: 'google_maps_search',
  targetType: 'brewery',
  cadence: 'monthly',
  status: 'active',
  nextDueLocal: '',
};

/**
 * @param {string | undefined | null} status
 * @param {string | undefined | null} pausedReason
 * @param {string | undefined | null} lastErrorMessage
 */
export function formatScheduleStatusLabel(status, pausedReason, lastErrorMessage) {
  const statusText = typeof status === 'string' && status.trim().length > 0 ? status.trim() : '—';
  const pausedReasonText =
    statusText === 'paused' &&
    typeof pausedReason === 'string' &&
    pausedReason.trim().length > 0
      ? pausedReason.trim()
      : '';
  if (pausedReasonText.length > 0) {
    return `${statusText} (${pausedReasonText})`;
  }
  const lastErrorText =
    statusText === 'error_suppressed' &&
    typeof lastErrorMessage === 'string' &&
    lastErrorMessage.trim().length > 0
      ? lastErrorMessage.trim()
      : '';
  if (lastErrorText.length > 0) {
    return `${statusText} (${lastErrorText})`;
  }
  return statusText;
}
